import React, { forwardRef, HTMLAttributes } from 'react';
import classNames from 'classnames';
import styles from './Card.module.scss';
// import { CardBodyProps } from './types';

export interface CardBodyProps extends HTMLAttributes<HTMLDivElement> {}

const CardBody = forwardRef<HTMLDivElement, CardBodyProps>(
  ({ className, children, ...props }, ref) => (
    <div className={classNames(styles.body, className)} ref={ref} {...props}>
      {children}
    </div>
  ),
);

CardBody.displayName = 'Card.Body';

export default CardBody;
